import React from 'react';
import BRAND from '../brand';
import { NAV_LINE_ICONS } from './NavIcons';

function Navigation({ activePage, setActivePage, cartCount }) {
  const navItems = [
    { id: 'menu', icon: '☰', label: 'Каталог' },
    { id: 'cart', icon: '🛒', label: 'Корзина' },
    { id: 'orders', icon: '📦', label: 'Мои заказы' },
    { id: 'profile', icon: '👤', label: 'Профиль' },
    { id: 'about', icon: 'ℹ️', label: 'О проекте' },
  ];

  return (
    <nav className="navigation">
      {navItems.map((item) => (
        <button
          key={item.id}
          className={`nav-item ${activePage === item.id ? 'active' : ''}`}
          onClick={() => setActivePage(item.id)}
        >
          <span className="nav-icon">
            {BRAND.navIconStyle === 'line' ? NAV_LINE_ICONS[item.id] : item.icon}
          </span>
          <span className="nav-label">{item.label}</span>
          {item.id === 'cart' && cartCount > 0 && (
            <span className="nav-badge">{cartCount}</span>
          )}
        </button>
      ))}
    </nav>
  );
}

export default Navigation;



